import DisplayHandler from "./components/DisplayHandler";
import AttributeHandler from "./components/AttributeHandler";
import AlertHandler from "./components/AlertHandler";
import EventHandler from "./components/EventHandler";
export default class ForceSelectAttribute {
  constructor({type}) {
    this.type = type;
  }
  setEvents() {
    if (this.type === "productpage") {
      this.setEventsForProductPage();
    } else if (this.type === "quickview") {
      this.setEventsForModal();
    }
  }
  runOnlyOnDefault() {
    if (this.type === "productpage") {
      return prestashop.forceattr.forceOnlyOnDefault == 1 && prestashop.forceattr.isDefaultAttribute == 0;
    } else if (this.type === "quickview") {
      return prestashop.forceattr.quickview_forceOnlyOnDefault == 1 && prestashop.forceattr.quickview_isDefaultAttribute == 0;
    }
  }
  setEventsForProductPage() {
    if (prestashop.forceattr.hasAttribute == 0 || this.runOnlyOnDefault()) {
      return;
    }
    const selector = "#product #main";
    const alert = new AlertHandler({
      type: this.type,
      alertType: prestashop.forceattr.alertType,
      alertText: prestashop.forceattr.alertText,
      appendSelector: "#product #main .js-product-form-actions"
    });
    const display = new DisplayHandler({
      type: this.type,
      container: selector
    });
    display.handle();
    this.events = new EventHandler({
      selector,
      type: this.type,
      attributeGroupHandler: this.attributeGroupHandler,
      alert,
      display,
      attrSelector: ".js-product-variants",
      qtySelector: "#quantity_wanted",
      addToCartSelector: '[data-button-action="add-to-cart"]'
    });
    prestashop.on("updatedProduct", () => {
      this.events.update();
    });
  }
  setEventsForModal() {
    if (prestashop.forceattr.quickview_hasAttribute == 0 && this.runOnlyOnDefault()) {
      return;
    }
    const selector = ".quickview.modal";
    const alert = new AlertHandler({
      type: this.type,
      alertType: "inline",
      alertText: prestashop.forceattr.quickview_alertText,
      appendSelector: ".quickview.modal .product-add-to-cart"
    });
    const display = new DisplayHandler({
      type: this.type,
      container: selector
    });
    display.handle();
    this.events = new EventHandler({
      selector,
      type: this.type,
      attributeGroupHandler: this.attributeGroupHandler,
      alert,
      display,
      attrSelector: ".product-variants",
      qtySelector: "#quantity_wanted",
      addToCartSelector: '[data-button-action="add-to-cart"]'
    });
    prestashop.on("updatedProduct", () => {
      if ($(".modal.quickview").length > 0) {
        this.events.update();
      }
    });
  }
  init() {
    this.attributeGroupHandler = new AttributeHandler({
      attrGroup: this.type === "productpage" ? prestashop.forceattr.attributeGroups : prestashop.forceattr.quickview_attributeGroups,
      attributeSelector: "[data-product-attribute={id}]"
    });
    this.setEvents();
  }
}
